<template>
  <el-container style="height: 100vh; border: 1px solid #eee">
    <el-header>
      <span style="font-size:20px;">Author Portal</span>
      <el-dropdown v-if="showSetting"
                   style="float:right"
                   trigger="click"
                   @command="handleCommand">
        <span class="el-dropdown-link">
          Setting
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePassword">Change Password</el-dropdown-item>
          <el-dropdown-item command="logout">Log Out</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <router-view></router-view>
  </el-container>
</template>

<script>
import Auth from './utils/auth';
import auth from './utils/auth';
export default {
  created() {
    this.showSetting = Auth.checkTokenAlive();
  },
  name: 'App',
  data() {
    return {
      showSetting: false,
    };
  },
  beforeUpdate() {
    this.showSetting = Auth.checkTokenAlive();
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'logout':
          this.logout();
          break;
        case 'changePassword':
          Auth.getRole() === 1
            ? this.$router.push(`/admin/${localStorage.userID}/password`)
            : this.$router.push(`/user/${localStorage.userID}/password`);
          break;
        default:
          break;
      }
    },
    logout() {
      Auth.logout(() => {
        this.$router.push('/login');
      });
    },
  },
};
</script>
<style lang="scss">
.el-header {
  background-color: #0670bb;
  color: #ffffff;
  line-height: 60px;
}

.el-aside {
}

.el-dropdown {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue